import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { getHeaderHeight } from './header.utils';
import { MEDIA_BREAKPOINTS } from '../../../../mediaQueries.const';
import { ErrorBoundary } from '../../../errorHandling/ErrorBoundary';

interface MontiAnchorProps {
  isSecondaryHeaderEnabled: boolean
  menuAnimation: any
}

const getStyle = (isSecondaryHeaderEnabled: boolean) => {
  const height = getHeaderHeight(isSecondaryHeaderEnabled);
  return StyleSheet.create({
    anchor: {
      position: 'fixed',
      top: height,
      left: 0,
      right: 0,
      height: 0,
      transition: '800ms',
    },
    foldingUp: {
      [MEDIA_BREAKPOINTS.MEDIUM]: {
        top: 0,
      },
      [MEDIA_BREAKPOINTS.SMALL]: {
        top: 0,
      },
    },
    foldingDown: {
      [MEDIA_BREAKPOINTS.MEDIUM]: {
        top: height,
      },
      [MEDIA_BREAKPOINTS.SMALL]: {
        top: height,
      },
    },
  });
};

export const MontiAnchor: React.FC<MontiAnchorProps> = props => {
  const { isSecondaryHeaderEnabled, menuAnimation } = props;
  const style = getStyle(isSecondaryHeaderEnabled);
  let finalStyle;
  switch (menuAnimation) {
    case 'foldingUp': finalStyle = css(style.anchor, style.foldingUp); break;
    case 'foldingDown': finalStyle = css(style.anchor, style.foldingDown); break;
    default: finalStyle = css(style.anchor);
  }

  return <ErrorBoundary><div className={`${finalStyle} video-top-anchor`} /></ErrorBoundary>;
};
